module.exports = __webpack_public_path__ + "img/csr4.87fcfd97.jpeg";